import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'egitim-kaydi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--egitim" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">EĞİTİM KAYDI</div>
        <div class="eg-ad gc-baslik-ana">{{ p()?.egitimAdi || 'Eğitim' }}</div>
        <div class="eg-alt">
          <span class="eg-sure">{{ p()?.sure || 1 }} saat</span>
          @if (p()?.sertifikaNo) { <span class="eg-sertifika">{{ p().sertifikaNo }}</span> }
        </div>
        @if (p()?.notlar) { <div class="eg-notlar">{{ p().notlar }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 70 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #7c3aed; --accent-rgb: 124,58,237; }
    .eg-ad { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .eg-alt { display: flex; align-items: center; gap: 8px; margin-top: 2px; }
    .eg-sure { font-size: 18px; font-weight: 900; color: #a78bfa; font-variant-numeric: tabular-nums; text-shadow: 0 0 10px rgba(167,139,250,.3); }
    .eg-sertifika { font-size: 8px; font-weight: 600; letter-spacing: .06em; padding: 2px 6px; border-radius: 2px; color: #fff; background: rgba(124,58,237,0.3); }
    .eg-notlar { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
})
export class EgitimKaydiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
